"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeCatchupStatus = void 0;
var NodeCatchupStatus;
(function (NodeCatchupStatus) {
    NodeCatchupStatus[NodeCatchupStatus["UpToDate"] = 0] = "UpToDate";
    NodeCatchupStatus[NodeCatchupStatus["Pending"] = 1] = "Pending";
    NodeCatchupStatus[NodeCatchupStatus["CatchingUp"] = 2] = "CatchingUp";
})(NodeCatchupStatus = exports.NodeCatchupStatus || (exports.NodeCatchupStatus = {}));
